import { Tag } from "antd";
import React, { Component } from "react";
import { ModalItem, TableItem } from "../../../../Components/Items";

// Ver industria: consulta de solo lectura de la industria y sus familias
class FamiliasIndustria extends Component {
    render() {
        const industria = this.props.industria;
        if (!industria) return null;

        const familias = industria.familias || [];

        const columns = [
            {
                title: "Número",
                dataIndex: "numero",
                key: "numero",
                width: "12%",
                render: (value) => (value || value === 0 ? value : "-"),
            },
            {
                title: "Nombre",
                dataIndex: "nombre",
                key: "nombre",
                buscar: "nombre",
                width: "38%",
            },
            {
                title: "Tipo de Familia",
                dataIndex: "tipoDeFamilia",
                key: "tipoDeFamilia",
                buscar: "tipoDeFamilia",
                width: "30%",
                render: (value) => value || "-",
            },
            {
                title: "Estado",
                dataIndex: "estado",
                key: "estado",
                width: "20%",
                render: (value) => {
                    if (value === 1) return <Tag color="green">Activo</Tag>;
                    if (value === 2) return <Tag color="orange">Deshabilitado</Tag>;
                    return <span>-</span>;
                },
            },
        ];

        return (
            <ModalItem
                title="Familias de la industria"
                visible={this.props.visible}
                onCancel={this.props.cerrarFamiliasIndustria}
                width={window.innerWidth > 1000 ? "60%" : "95%"}
                paddingTop
            >
                <div
                    style={{
                        background: "#fff",
                        border: "1px solid #eef1f2",
                        borderRadius: 12,
                        padding: "10px 14px",
                        marginBottom: 12,
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: 10,
                            flexWrap: "wrap",
                        }}
                    >
                        <span style={{ fontSize: 15, fontWeight: 700, color: "#3c4b53" }}>
                            {industria.nombre}
                        </span>
                        <Tag color="cyan">
                            {familias.length === 1
                                ? "1 familia relacionada"
                                : familias.length + " familias relacionadas"}
                        </Tag>
                    </div>
                    {industria.descripcion ? (
                        <div style={{ fontSize: 12, color: "#7b8a92", marginTop: 4 }}>
                            {industria.descripcion}
                        </div>
                    ) : null}
                </div>

                {familias.length === 0 ? (
                    <div
                        style={{
                            background: "#fafbfc",
                            border: "1px dashed #dfe4e6",
                            borderRadius: 12,
                            padding: "26px 14px",
                            textAlign: "center",
                            fontSize: 13,
                            color: "#7b8a92",
                            marginBottom: 10,
                        }}
                    >
                        Esta industria aún no tiene familias relacionadas.
                    </div>
                ) : (
                    <TableItem
                        size="small"
                        dataSource={familias}
                        columns={columns}
                        scroll={{ x: "max-content" }}
                    />
                )}
            </ModalItem>
        );
    }
}

export default FamiliasIndustria;
